// Alle gedrag van de site, zonder jQuery. Elke module zoekt zelf zijn elementen op en doet niets als die er niet zijn.
import "./menu";
import "./search";
import "./overview";
import "./faq";
import "./slider";
import "./video";
import "./storyScroll";
import "./readspeaker";
